import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";

export default function HeroSection() {
  const [isHovered, setIsHovered] = useState(false);
  const contentSectionRef = useRef(null);
  const dividerRef = useRef(null);
   const navigate = useNavigate();
  // Handle hover effect on button
  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  useEffect(() => {
    setTimeout(() => {
        const contentElements = document.querySelectorAll(
            ".content-subgrid h1, .content-subgrid p, .content-subgrid button, .content-subgrid img"
        );
        contentElements.forEach((el) => {
            el.style.opacity = 1;
            el.style.transform = "translateY(0px)";
        });

      
        if (dividerRef.current) {
            dividerRef.current.style.width = "100%";
        }

     
        const handleScroll = () => {
            const scrollPosition = window.scrollY;
            const heroSection = document.querySelector(".hero-section");
            if (heroSection) {
                const heroSectionHeight = heroSection.offsetHeight;
                const paddingTop = parseFloat(getComputedStyle(heroSection).paddingTop);
                const paddingBottom = parseFloat(getComputedStyle(heroSection).paddingBottom);
                const parallaxSpeed = 0.2;

                const effectiveHeight = heroSectionHeight - paddingTop - paddingBottom;

                if (scrollPosition < effectiveHeight) {
                    let offset = scrollPosition * parallaxSpeed;
                    const maxOffset = effectiveHeight - paddingBottom;

                    if (offset > maxOffset) offset = maxOffset;

                    const opacity = 1 - scrollPosition / effectiveHeight;

                    if (contentSectionRef.current) {
                        contentSectionRef.current.style.transform = `translateY(${offset}px)`;
                        contentSectionRef.current.style.opacity = opacity > 0 ? opacity : 0;
                    }
                } else {
                    if (contentSectionRef.current) {
                        contentSectionRef.current.style.transform = "translateY(0px)";
                        contentSectionRef.current.style.opacity = 0;
                    }
                }
            }
        };

        window.addEventListener("scroll", handleScroll);

        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, 1000);
}, []);

const [showScrollIndicator, setShowScrollIndicator] = useState(true);

// Hide scroll indicator after user scrolls
useEffect(() => {
  const handleScroll = () => {
    if (window.scrollY > 10) {
      setShowScrollIndicator(false);
    } else {
      setShowScrollIndicator(true);
    }
  };

  window.addEventListener("scroll", handleScroll);

  return () => {
    window.removeEventListener("scroll", handleScroll);
  };
}, []);

  return (
    <section className="hero-section" id="section1">
      <section className="video-background">
      <div className="hero-img-section">
                <img src="/assets/images/home-banner.webp" alt="" role="presentation" loading="eager"/>
            </div>
        <div className="content-section" ref={contentSectionRef}>
          <div className="content-subgrid">
            <h1 className="text-balance">
              Transforming Payments Into Trusted Connections
            </h1>
            <div
              className="divider"
              ref={dividerRef}
              style={{ width: "0%" }}
            ></div>
        {/* <p className="text-balance"> We accept ACH transfers, as well as Visa, MasterCard, and Discover credit and debit cards. We also support payments through Google Pay and Apple Pay.</p> */}
        <article className="card card--payment">
                        <p className="payment-label">
                            We accept <strong>ACH, Visa, MasterCard and Discover</strong> — credit and debit cards.
                        </p>
                    
                        <div className="payment-methods mb-0" role="list" aria-label="Accepted payment methods">
                            <div className="d-flex align-items-center justify-content-center">
                                <div className="method-chip" role="listitem" aria-label="">
                                    <img src="/assets/images/payment-method/visa.webp" alt="Pay with Visa" loading="lazy"/>
                                </div>
                            </div>
                            <div className="d-flex align-items-center justify-content-center">
                                <div className="method-chip" role="listitem" aria-label="">
                                    <img src="/assets/images/payment-method/card.webp" alt="Pay with Mastercard" loading="lazy"/>
                                </div>
                            </div>
                            <div className="d-flex align-items-center justify-content-center">
                                <div className="method-chip" role="listitem" aria-label="">
                                    <img src="/assets/images/payment-method/google-pay.webp" alt="Pay with Google Pay" loading="lazy"/>
                                </div>
                            </div>
                            <div className="d-flex align-items-center justify-content-center">
                                <div className="method-chip" role="listitem" aria-label="">
                                    <img src="/assets/images/payment-method/apple-pay.webp" alt="Pay with Apple Pay" loading="lazy"/>
                                </div>
                            </div>
                            <div className="d-flex align-items-center justify-content-center">
                                <div className="method-chip" role="listitem" aria-label="">
                                    <img src="/assets/images/payment-method/discover.webp" alt="Pay with Discover" loading="lazy"/>
                                </div>
                            </div>
                        </div>
                    
                        <button className={`btn btn-primary paynow-btn ${isHovered ? "hovered" : ""}`}
              type="button"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              onClick={()=>navigate('/Pay')}>
                            <span>Make Payment</span>
                            <span className="cta-arrow" aria-hidden="true">→</span>
                        </button>
  <p className="payment-label">Your data is safe.
                            Never worry about your details being shared or compromised on our secure website. All data is sent over an encrypted
                            SSL connection. We take your privacy very seriously.
                        </p>
                    </article>
          </div>
        </div>
        {/* {showScrollIndicator && (
  <div
    className="scroll-indicator"
    id="scrollIndicator"
    onClick={() => {
      window.scrollTo({
        top: window.innerHeight + 50,
        behavior: "smooth",
      });
    }}
  >
    <span className="arrow"><i className="bx bx-chevrons-down"></i></span>
  </div>
)} */}
      </section>
    </section>
  );
}
